function forceSlideshowFirstSlideVisible(panel) {
  const slideshows = panel.querySelectorAll("slideshow-component");

  slideshows.forEach((slideshow) => {
    // 1) Force Horizon to treat this slideshow as "actioned"
    // (helps content-visibility rules)
    slideshow.setAttribute("actioned", "");

    // 2) Force aria-hidden state so at least the first slide paints
    // Only consider slides that are not hidden (or are revealed)
    const allSlides = Array.from(slideshow.querySelectorAll("slideshow-slide"));
    const slides = allSlides.filter(
      (s) => !s.hasAttribute("hidden") || s.hasAttribute("reveal")
    );

    if (!slides.length) return;

    slides.forEach((s, i) => {
      s.setAttribute("aria-hidden", i === 0 ? "false" : "true");
    });

    // 3) If the custom element exposes select(), poke it so it syncs internal state
    // We temporarily change current so select(0) won't early-return.
    try {
      if (typeof slideshow.select === "function") {
        slideshow.current = -999; // ensure currentSlide !== requestedSlide
        slideshow.select(0, undefined, { animate: false });
      }
    } catch (e) {
      // ignore — we already forced aria-hidden above
    }
  });
}

function nudgeLayout() {
  // Horizon carousels/slideshows react to resize
  window.dispatchEvent(new Event("resize"));
}

function init(section) {
  const tabs = Array.from(section.querySelectorAll("[data-ctpc-tab]"));
  const panels = Array.from(section.querySelectorAll("[data-ctpc-panel]"));

  if (!tabs.length || !panels.length) return;

  const show = (index) => {
    tabs.forEach((t) => {
      const active = t.dataset.index === String(index);
      t.setAttribute("aria-selected", active ? "true" : "false");
    });

    panels.forEach((p) => {
      const active = p.dataset.index === String(index);
      p.classList.toggle("is-hidden", !active);

      if (active) {
        // Wait until the panel is actually visible in layout,
        // then force slideshow visibility + recalc.
        requestAnimationFrame(() => {
          forceSlideshowFirstSlideVisible(p);
          nudgeLayout();

          // A second pass helps in Safari / slower devices
          setTimeout(() => {
            forceSlideshowFirstSlideVisible(p);
            nudgeLayout();
          }, 60);
        });
      }
    });
  };

  tabs.forEach((t) => {
    t.addEventListener("click", () => show(t.dataset.index));
  });

  // Initialize first panel
  show(tabs[0].dataset.index);
}

function boot(root = document) {
  root.querySelectorAll("[data-ctpc-section]").forEach(init);
}

document.addEventListener("DOMContentLoaded", () => boot());

// Theme editor re-renders sections
document.addEventListener("shopify:section:load", (event) => {
  boot(event.target);
});
